import { dynamicImage } from "../../../Service/DynamicImage";

//Slides Only
export const SLIDES_ONLY = [
  {
    text: "The ",
    code: ".active",
  },
  {
    text: " class needs to be added to one of the slides otherwise the carousel will not be visible.",
    code: ".d-block",
  },
  {
    text: " and ",
    code: ".w-100 ",
  },
  {
    text: " on carousel images to prevent browser default image alignment.",
  },
];

export const SLIDES_ONLY_DATA = [
  {
    id: 1,
    image: `${dynamicImage(`slider/11.jpg`)}`,
  },
  {
    id: 2,
    image: `${dynamicImage(`slider/9.jpg`)}`,
  },
  {
    id: 3,
    image: `${dynamicImage(`slider/6.jpg`)}`,
  },
];

//With Controls
export const WITH_CONTROLS = [
  {
    text: "Use the ",
    code: ".carousel-control-prev",
  },
  {
    text: " & ",
    code: "carousel-control-next",
  },
  {
    text: " through previous and next controls. We recommend using ",
    code: "<button>",
  },
  {
    text: " elements, but you can also use ",
    code: "<a>",
  },
  {
    text: " elements with ",
    code: "role='button'.",
  },
];

export const WITH_CONTROL_DATA = [
  {
    id: 4,
    image: `${dynamicImage(`slider/6.jpg`)}`,
  },
  {
    id: 5,
    image: `${dynamicImage(`slider/7.jpg`)}`,
  },
  {
    id: 6,
    image: `${dynamicImage(`slider/10.jpg`)}`,
  },
  {
    id: 7,
    image: `${dynamicImage(`slider/4.jpg`)}`,
  },
  {
    id: 8,
    image: `${dynamicImage(`slider/1.jpg`)}`,
  },
];

//Auto Play Variant
export const AUTO_PLAY = [
  {
    text: "Use the ",
    code: ".carousel-control-prev",
  },
  {
    text: " & ",
    code: "carousel-control-next",
  },
  {
    text: " through previous and next controls. We recommend using ",
    code: "<button>",
  },
  {
    text: " elements, but you can also use ",
    code: "<a>",
  },
  {
    text: " elements with ",
    code: "role='button'.",
  },
];

export const AUTO_PLAY_DATA = [
  {
    id: 9,
    image: `${dynamicImage(`slider/1.jpg`)}`,
  },
  {
    id: 10,
    image: `${dynamicImage(`slider/2.jpg`)}`,
  },
  {
    id: 11,
    image: `${dynamicImage(`slider/3.jpg`)}`,
  },
  {
    id: 12,
    image: `${dynamicImage(`slider/4.jpg`)}`,
  },
  {
    id: 13,
    image: `${dynamicImage(`slider/5.jpg`)}`,
  },
  {
    id: 14,
    image: `${dynamicImage(`slider/6.jpg`)}`,
  },
  {
    id: 15,
    image: `${dynamicImage(`slider/7.jpg`)}`,
  },
  {
    id: 16,
    image: `${dynamicImage(`slider/8.jpg`)}`,
  },
  {
    id: 17,
    image: `${dynamicImage(`slider/9.jpg`)}`,
  },
  {
    id: 18,
    image: `${dynamicImage(`slider/10.jpg`)}`,
  },
  {
    id: 19,
    image: `${dynamicImage(`slider/11.jpg`)}`,
  },
];

//With Indicator
export const WITH_INDICATOR = [
  {
    text: "Use the ",
    code: ".carousel-indicators",
  },
  {
    text: " through carousel indicates.",
  },
];

export const WITH_INDICATOR_DATA = [
  {
    id: 20,
    image: `${dynamicImage(`slider/3.jpg`)}`,
  },
  {
    id: 21,
    image: `${dynamicImage(`slider/8.jpg`)}`,
  },
  {
    id: 22,
    image: `${dynamicImage(`slider/10.jpg`)}`,
  },
];

//With Captions
export const WITH_CAPTION = [
  {
    text: "Add captions to your slides easily with the",
    code: " .carousel-caption",
  },
  {
    text: " element within any ",
    code: ".carousel-item",
  },
];

export const WITH_CAPTION_DATA = [
  {
    id: 23,
    image: `${dynamicImage(`slider/9.jpg`)}`,
    captionText: "You can watch folks you wouldn't have in your house amuse you in your living room thanks to the development of television.",
    captionHeader: "The area in the house that is most comfortable.",
  },
  {
    id: 24,
    image: `${dynamicImage(`slider/1.jpg`)}`,
    captionText: "Regardless of how big or tiny your home is, think about hiring an interior designer. They give you a calm living atmosphere in addition to decorating your home.",
    captionHeader: "Drawing Room",
  },
  {
    id: 25,
    image: `${dynamicImage(`slider/2.jpg`)}`,
    captionText: "If you want to alter your way of life, start with redesigning your house's interior.",
    captionHeader: "House Interior",
  },
];

//Cross Fades
export const CROSS_FADE = [
  {
    text: "Add ",
    code: "carousel-fade",
  },
  {
    text: " to your carousel to animate slides with a fade transition instead of a slide. Depending on your carousel content, you may want to add",
    code: " .bg-body",
  },
  {
    text: " or some custom CSS to the .carousel-items for proper cross-fading.",
  },
];

export const CROSS_FADE_DATA = [
  {
    id: 26,
    image: `${dynamicImage(`slider/1.jpg`)}`,
  },
  {
    id: 27,
    image: `${dynamicImage(`slider/11.jpg`)}`,
  },
  {
    id: 28,
    image: `${dynamicImage(`slider/7.jpg`)}`,
  },
  {
    id: 29,
    image: `${dynamicImage(`slider/10.jpg`)}`,
  },
];

//Individual Carousel Item Intervals
export const ITEM_INTERVAL = [
  {
    text: "Add ",
    code: 'data-bs-interval=""',
  },
  {
    text: " to a",
    code: " .carousel-item",
  },
  {
    text: "  to change the amount of time to delay between automatically cycling to the next item.",
  },
];

export const ITEM_INTERVAL_DATA = [
  {
    id: 30,
    image: `${dynamicImage(`slider/5.jpg`)}`,
    interval: 1000,
  },
  {
    id: 31,
    image: `${dynamicImage(`slider/2.jpg`)}`,
    interval: 3000,
  },
  {
    id: 32,
    image: `${dynamicImage(`slider/10.jpg`)}`,
    interval: 10000,
  },
];

//Disable Touch Swipings
export const DISABLE_TOUCH = [
  {
    text: "Carousels support swiping left/right on touchscreen devices to move between slides. This can be disabled using the ",
    code: "data-bs-touch ",
  },
  {
    text: " attribute.",
  },
];

export const DISABLE_TOUCH_DATA = [
  {
    id: 30,
    image: `${dynamicImage(`slider/4.jpg`)}`,
  },
  {
    id: 31,
    image: `${dynamicImage(`slider/8.jpg`)}`,
  },
  {
    id: 32,
    image: `${dynamicImage(`slider/6.jpg`)}`,
  },
];

//Dark Variant
export const DARK_VARIANT = [
  {
    text: "Add ",
    code: ".carousel-dark",
  },
  {
    text: "  to the ",
    code: ".carousel",
  },
  {
    text: "  for darker controls, indicators, and captions. ",
  },
];

export const DARK_VARIANT_DATA = [
  {
    id: 33,
    image: `${dynamicImage(`slider/1.jpg`)}`,
    captionText: "If you have been dreaming about bringing your living room together, our designers are here to help. Come see what we can do for your space.",
    captionHeader: "We decorate our homes",
  },
  {
    id: 34,
    image: `${dynamicImage(`slider/3.jpg`)}`,
    captionText: "A sofa is the ideal spot to enjoy a movie, nod off, and wake up.",
    captionHeader: "This couch is a great topic of conversation.",
  },
  {
    id: 35,
    image: `${dynamicImage(`slider/6.jpg`)}`,
    captionText: "A house you can create with your friends is a great place.",
    captionHeader: "Sometimes all you really need to unwind is a comfortable couch.",
  },
];
